import "./headers-central.css";
import { useAuth } from "../../contexts/authContexts";
import NavBar from "../../components/NavBar";

export const HeadersCentral = ({ showDropdown, setShowDropdown, openModal }) => {
  const { logout } = useAuth();

  return (
    <NavBar
      showDropdown={showDropdown}
      setShowDropdown={setShowDropdown}
      openModal={openModal}
      onLogout={logout}
    />
  );
};
